import App from './components/App';

const app = new App({
	target: document.getElementById('support-bubble')
});

export default app;
